import React, { useState, useEffect, useContext } from "react";

import lbl from "../../../data/Labels.json";
import db from "../../../services/query";

import PrintHeader from "../common/PrintHeader";
import PrintBodyTitle from "../common/PrintBodyTitle";
import PrintTable from "../common/PrintTable";
import RowPhoto from "../../common/TdImg";

import { HalfYearContext } from "../../../contexts/halfYearContext";

const StudentFeesByClass = (props) => {
  let printHeadTexts = ["معاونیت امور مالی و اداری", "مدیریت مالی"];
  const [tableTitles, setTableTitles] = useState({ mainTitle: "" });

  const { halfYear } = useContext(HalfYearContext);

  const columns = [
    { path: "id", label: "شماره" },
    {
      path: "student_photo",
      label: "عکس",
      content: ({ student_photo }) => <RowPhoto src={student_photo} />,
    },
    { path: "aria_id", label: "کد دانشجو" },
    {
      path: "full_name",
      label: "اسم",
    },
    { path: "student_father_name", label: "ولد" },
    { path: "fee", label: "فیس" },
    { path: "discount", label: "تخفیف" },
    { path: "paid", label: "پرداخت شده" },
    { path: "payable", label: "باقی‌مانده" },
    { path: "current_overall_balance", label: "مجموعه باقی" },
    { path: "option" },
  ];

  const [data, setData] = useState([]);

  useEffect(() => {
    requestData({ halfYear });

    return () => setData([]);
  }, []);

  const requestData = async (p = new Object()) => {
    try {
      const { halfYear } = p;

      const { fid, cid } = props.match.params;

      let query = `students/fees/faculties/${fid}/classes/${cid}?halfYearId=${halfYear}`;

      await db.getAll(query).then(({ data }) => {
        setData(data);
        setTableTitles({ mainTitle: data.summary.title });
      });
    } catch ({ response }) {
      setData(response);
    }
  };

  return (
    <main className="main-print-wrapper">
      <PrintHeader title={lbl.StudentsFees} printHeadTexts={printHeadTexts} />
      <PrintBodyTitle title={tableTitles} />
      <PrintTable columns={columns} data={data} />
    </main>
  );
};

export default StudentFeesByClass;
